module.exports = __webpack_public_path__ + "img/analytics-download-bg-dark.27d7925d.png";